<template><svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 612 612"
>
	<g transform="scale(.9) translate(20, 40)">
		<path d="M0,267.75c0,71.394,48.979,117.58,115.113,130.222c-0.115,1.225-0.363,2.41-0.363,3.653v153
			c0,21.133,17.117,38.25,38.25,38.25h57.375c21.133,0,38.25-17.136,38.25-38.25v-153H306v-267.75H153
			C68.506,133.875,0,183.256,0,267.75z M344.25,401.625h57.375v-267.75H344.25V401.625z M573.75,19.125l-133.875,89.256v318.756
			l133.875,89.237c21.133,0,38.25-17.117,38.25-38.25V57.375C612,36.261,594.883,19.125,573.75,19.125z"/>
	</g>
</svg>
</template>